import { useCallback, useMemo, useState } from 'react';
import type { BreadcrumbItem } from '@/shared/ui/MainLayoutProvider';

export const useMainBreadcrumbs = () => {
  const [breadcrumbs, setState] = useState<BreadcrumbItem[]>([]);

  const setBreadcrumbs = useCallback((items: BreadcrumbItem[]) => {
    setState(normalizeCurrent(items));
  }, []);

  const addBreadcrumbs = useCallback((...items: BreadcrumbItem[]) => {
    const toAppend = Array.isArray(items) ? items : [items];
    setState((prev) => normalizeCurrent(dedupeByPath(prev, toAppend)));
  }, []);

  const clearBreadcrumbs = useCallback(() => setState([]), []);

  return useMemo(
    () => ({ breadcrumbs, addBreadcrumbs, setBreadcrumbs, clearBreadcrumbs }),
    [{ breadcrumbs, addBreadcrumbs, setBreadcrumbs, clearBreadcrumbs }],
  );
};

function normalizeCurrent(items: BreadcrumbItem[]): BreadcrumbItem[] {
  if (!items.length) return items;
  const cleared = items.map((it) => ({ ...it, isCurrent: false }));
  cleared[cleared.length - 1].isCurrent = true;
  return cleared;
}

function dedupeByPath(existing: BreadcrumbItem[], incoming: BreadcrumbItem[]): BreadcrumbItem[] {
  if (!incoming.length) return existing;
  const existingPaths = new Set(existing.map((it) => it.path).filter(Boolean));
  const toAdd = incoming.filter((it) => (it.path ? !existingPaths.has(it.path) : true));
  return [...existing, ...toAdd];
}
